var React = require('react');

function CloseInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M18.4006 1.60001L1.60059 18.4","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M1.60059 1.60001L18.4006 18.4","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

CloseInline.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = CloseInline;

CloseInline.default = CloseInline;
